import React, { useState, useEffect } from "react";
import axios from "axios";

// component
import DealerProfileSearchbar from "../DealerProfileSearchbar";
import DealerProfileNavbar from "../DealerProfileNavbar";
import MainFooter from "../../Footer/MainFooter";
import TermFooter from "../../Footer/TermFooter";

// css
import "../../../Css/UserDealerQR.css";
import "../../../App.css";

// api & qr url
import { apiUrl } from "../../../Private";

const DealerQR = () => {
  const [dealerData, setDealerData] = useState();

  const apiKey = JSON.parse(localStorage.getItem("KTMauth"));

  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // get dealer data
  useEffect(() => {
    const profileUrl = `${apiUrl}/v3/api/view-profile/dealer/${apiKey['tokens']['refresh']}`;

    axios.get(profileUrl, null, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `${apiKey['tokens']['refresh']}`
      }
    })
      .then((response) => {
        setDealerData(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <DealerProfileSearchbar />

      <DealerProfileNavbar />

      {dealerData !== undefined ? (
        <div className="user__dealer__qr__section similar__section">
          <h1 className="similar__section__heading">Your QR Code</h1>
          <div className="user__dealer__qr">
            <img src={`${apiUrl}/${dealerData.qrCode}`} alt="QR Code" />
            <h1>{dealerData.email}</h1>
            <h1>{dealerData.username}</h1>
            <h1>{dealerData.account_type}</h1>
          </div>
        </div>
      ) : null}

      <MainFooter />

      <TermFooter />
    </>
  );
};

export default DealerQR;
